import { createLogger } from 'shared/services/logger';
import {translate} from 'shared/services/I18nService';

const logger = createLogger('UScope:extensions:Snapshot:EventCoordinator');

export function go (notifications, viewport, eventChannel, settings, snapshotUi, downloader, regionOfInterest, viewportHelper) {
  const $t = translate.scope('uScope.extensions.snapshot.notices');
  // If the user presses escape, just clean up.
  eventChannel.on('drawing:user-cancelled', wrapThingsUp);
  // Restore UI functionality as soon as the user's done drawing
  eventChannel.on('drawing:user-action-complete', restoreAllTheHiddenThings);

  eventChannel.on('drawing:complete', startCapturePhase);

  hideUnwantedItemsFromView();
  startDrawPhase();

  function hideUnwantedItemsFromView () {
    snapshotUi.hide();
    viewportHelper.hideOverlays();
  }

  function restoreAllTheHiddenThings () {
    // Since the tool is now the main UI, it should come back.
    snapshotUi.show();
    viewportHelper.showOverlays();
  }

  function startDrawPhase () {
    try {
      regionOfInterest.draw(viewport, settings);
    } catch (e) {
      wrapThingsUp($t('create-failed'), e);
    }
  }

  async function startCapturePhase (rectangle, zoom) {
    if (rectangle.area === 0) {
      wrapThingsUp();
      return;
    }

    notifications.information($t('starting-download'));

    try {
      await downloader.download(viewport, rectangle, zoom);
      wrapThingsUp($t('success'));
    } catch (e) {
      wrapThingsUp($t('download-failed'), e);
    }
  }

  function wrapThingsUp (message, exception) {
    if (message) {
      notifications[exception ? 'error' : 'done'](message);
    }

    if (exception) {
      logger.error(exception);
    }

    // In some cases this is redundant, but better to err on the side of restoring functionality to the user.
    restoreAllTheHiddenThings();

    // We're done. Clean up event listeners.
    eventChannel.$destroy();
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/snapshot-event-coordinator.js